/** 共享平台占位数据（前端演示，不接后端） */

export type TeamOpenSharedDevice = {
  id: string;
  name: string;
  model: string;
  location: string;
  /** 对外展示状态 */
  exposure: '已开放' | '待配置' | '已暂停';
  openRule: string;
  approver: string;
  reception: string;
  fee: string;
};

export type CrossTeamSharedDevice = {
  id: string;
  name: string;
  model: string;
  location: string;
  owningTeam: string;
  platformName: string;
  exposure: '已上架' | '审批中' | '已下架';
  openRule: string;
};

export const MOCK_TEAM_OPEN_DEVICES: TeamOpenSharedDevice[] = [
  {
    id: 't1',
    name: '高分辨液质联用仪',
    model: 'Q Exactive HF-X',
    location: '分析测试中心 A102',
    exposure: '已开放',
    openRule: '工作日 09:00–18:00，需提前 1 天预约',
    approver: '张教授',
    reception: '李助理 · 138****0001',
    fee: '校内 200 元/样，校外面议'
  },
  {
    id: 't2',
    name: '激光共聚焦显微镜',
    model: 'LSM 980',
    location: '影像平台 B203',
    exposure: '已开放',
    openRule: '周二、周四开放外部时段',
    approver: '王管理员',
    reception: '前台值班 · 010-****8888',
    fee: '按小时计费，详见价目表'
  },
  {
    id: 't3',
    name: '流式细胞仪',
    model: 'BD FACSymphony A5',
    location: '细胞房 C015',
    exposure: '待配置',
    openRule: '规则尚未保存',
    approver: '—',
    reception: '—',
    fee: '—'
  }
];

export const MOCK_CROSS_TEAM_DEVICES: CrossTeamSharedDevice[] = [
  {
    id: 'p1',
    name: '核磁共振波谱仪',
    model: 'AVANCE NEO 600',
    location: '结构中心 D101',
    owningTeam: '分子影像团队（MOLEC）',
    platformName: '长三角大型仪器协作网（演示）',
    exposure: '已上架',
    openRule: '平台规则：跨团队审批 + 统一接待窗口'
  },
  {
    id: 'p2',
    name: '冷冻透射电镜',
    model: 'Titan Krios G4',
    location: '电镜中心 E001',
    owningTeam: '本团队',
    platformName: '长三角大型仪器协作网（演示）',
    exposure: '已上架',
    openRule: '本设备使用平台独立价目与时段策略'
  },
  {
    id: 'p3',
    name: '超高速分选型流式',
    model: 'FACSAria Fusion',
    location: '免疫平台 F112',
    owningTeam: '免疫与感染团队（IMM）',
    platformName: '长三角大型仪器协作网（演示）',
    exposure: '审批中',
    openRule: '待对方团队管理员确认上架'
  }
];
